import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './authContext';
import { UsersResponse } from '../service.type';
import { GetUserContextType } from './getUserContext.type';

const UserSummaryContext = createContext<GetUserContextType | undefined>(
  undefined,
);

export const UserSummaryProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [usersSummary, setUsersSummary] = useState<UsersResponse>();
  const { accessToken } = useAuth();

  useEffect(() => {
    console.log({ accessToken });

    if (!accessToken) {
      setUsersSummary(undefined);
      return;
    }
  }, [accessToken]);

  return (
    <UserSummaryContext.Provider value={{ usersSummary, setUsersSummary }}>
      {children}
    </UserSummaryContext.Provider>
  );
};

export const useUserSummary = (): GetUserContextType => {
  const context = useContext(UserSummaryContext);
  if (!context) throw new Error('useAuth must be used inside AuthProvider');
  return context;
};
